import { SelectProps } from '@heathmont/moon-components';
import { Label, mergeClassnames } from '@heathmont/moon-core-tw';
import { rem } from '@heathmont/moon-utils';

type Props = SelectProps & {
  children: React.ReactNode;
  name?: string;
  label: string;
  ref?: React.ForwardedRef<HTMLSelectElement>;
  placeholder?: string;
  maxiWidth?: string;
  error?: boolean;
};

const CustomSelect: React.FC<Props> = ({ children, maxiWidth, ...props }) => (
  <div className="flex flex-col w-full h-full justify-between">
    <Label className="text-trunks text-moon-16 w-full">{props.label}</Label>
    <select
      {...props}
      className={mergeClassnames(
        `h-10 px-2 text-trunks border cursor-pointer border-beerus bg-gohan hover:border-goten duration-200 ease-in-out delay-0 w-radix-dropdown-menu-content-available-width rounded-lg`,
        maxiWidth ? `max-w[${maxiWidth}]` : `max-w-[${rem(360)}]`,
        props.error && 'border-piccolo',
      )}
    >
      {children}
    </select>
  </div>
);

export default CustomSelect;
